<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <ng-word></ng-word>
      </div>
    </div>
  </div>
</template>

<script>
import NgWord from "../components/NGWord.vue";
export default {
  components: {
    NgWord
  }
};
</script>
